import { api } from 'common';
import { isTruthy } from '../components/utils';

///////////////////////////////////////////////////
////// PUBLIC
export const getCoordinates = async (): Promise<
  api.Places.Geometry | undefined
> => {
  try {
    const pos = await getMaybeBrowserGeoLocation();
    return {
      latitude: pos.coords.latitude,
      longitude: pos.coords.longitude,
    };
  } catch (err) {
    console.log(err);
    // throw error only if it's not a geolocation permission denied issue
    const shouldThrowError =
      !(err instanceof GeolocationPositionError) ||
      err?.code !== GeolocationPositionError.PERMISSION_DENIED;

    if (shouldThrowError) {
      throw new Error(
        `Unable to retrieve browser geolocation: ${err?.message}`,
      );
    }
    return undefined;
  }
};

export const format = (
  address: api.Places.BasePlaceDetail | api.Address.Address,
) => {
  let contents;
  contents = isPlaceDetail(address)
    ? [
        address.addressOne,
        address.addressTwo,
        address.city,
        address.state,
        address.zipCode,
      ]
    : [address.address, address.unitNumber, address.city, address.state];
  return contents.filter(isTruthy).join(', ');
};

export const generateGoogleMapsDirectionURL = ({
  address,
  city,
  state,
  zip,
}: {
  address: string;
  city: string;
  state: string;
  zip: string;
}) => {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    `${address} ${city} ${state} ${zip}`,
  )}`;
};

///////////////////////////////////////////////////
////// PRIVATE

function isPlaceDetail(
  address: api.Places.BasePlaceDetail | api.Address.Address,
): address is api.Places.BasePlaceDetail {
  return (address as api.Places.BasePlaceDetail).addressTwo !== undefined;
}

const getMaybeBrowserGeoLocation = async (): Promise<GeolocationPosition> => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
};
